import { Car, Bike, Zap, Gauge, Mountain, Flag, Rocket, Layers } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * T-179: motorcycle posts were showing a CAR icon.
 *
 * The cause was a fallback, not a mapping mistake. Two separate places each
 * wrote their own ternary over the category list:
 *
 *   post.category === 'motorcycles' ? Bike : post.category === 'ev' ? Zap : Car
 *   source.category === 'motorcycles' ? Bike : Car
 *
 * The feed has SEVEN categories (cars, motorcycles, scooters, ev, adv,
 * motorsport, launches). Each ternary named two or three of them and let
 * everything else fall through to `Car` — so scooters, ADV and motorsport
 * posts were all labelled with a car, and any category added later would be
 * too. "Car" is not a neutral default on a site that is half motorcycles.
 *
 * One exhaustive map, keyed by the same category values the feed filter and
 * the backend enum use, replaces both. `Layers` is the only fallback and it
 * is deliberately generic: an unknown category should look unknown, not look
 * like a car.
 */
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  cars: Car,
  motorcycles: Bike,
  scooters: Gauge,
  ev: Zap,
  adv: Mountain,
  motorsport: Flag,
  launches: Rocket,
};

export function getCategoryIcon(category: string | null | undefined): LucideIcon {
  if (!category) return Layers;
  return CATEGORY_ICONS[category] ?? Layers;
}
